import { useEffect, useRef } from 'react';
import { useNextRouter } from '@/data/Content/_NextRouter';

export const usePreviousRoute = () => {
	const router = useNextRouter();
	const previousPath = useRef<string | null>(null);

	useEffect(() => {
		const handleRouteChange = (_: string) => {
			previousPath.current = router.asPath;
		};

		router.events.on('routeChangeStart', handleRouteChange);
		return () => {
			router.events.off('routeChangeStart', handleRouteChange);
		};
	}, [router]);

	return previousPath.current;
};
